import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Macos = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="m8.53 13.333-.153-1.344c-.125.007-.25.011-.377.011-2.534 0-4.667-1.422-4.667-3.333h1.334c0 1.034 1.448 2 3.333 2 .075 0 .15-.002.224-.005l-.152-1.329H5.861l1.27-6.666H3.333a.667.667 0 0 0-.666.666v9.334c0 .368.298.666.666.666h5.198Zm1.343 0h2.794a.667.667 0 0 0 .666-.666V3.333a.667.667 0 0 0-.666-.666H8.488L7.472 8h1.79l.278 2.434c1.079-.348 1.793-1.041 1.793-1.767h1.334c0 1.463-1.25 2.639-2.973 3.11l.179 1.556Zm-6.54-12h9.334a2 2 0 0 1 2 2v9.334a2 2 0 0 1-2 2H3.333a2 2 0 0 1-2-2V3.333a2 2 0 0 1 2-2ZM4 4.667h1.333v2H4v-2Zm6.667 0H12v2h-1.333v-2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Macos;
